/* eslint-disable no-prototype-builtins */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Component,
  OnDestroy,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { AuthService } from 'src/app/service/auth.service';
import { PortfolioApiService } from 'src/app/shared/services/customer-api/portfolio-api.service';
import { QueryApiService } from 'src/app/shared/services/customer-api/query-api.service';
import { FilterApiService } from 'src/app/shared/services/customer-api/filter-api.service';
import { NewsletterApiService } from 'src/app/shared/services/customer-api/newsletter-api.service';
import { RoutingService } from 'src/app/service/routing.service';
import { NewsletterService } from 'src/app/service/newsletter.service';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ConfigService } from 'src/app/service/config.service';
import { MatLegacyTabNav as MatTabNav } from '@angular/material/legacy-tabs';

const FREQUENCY_TO_TIME: Record<string, string> = {
  DAILY: '2',
  WEEKLY: '7',
  MONTHLY: '30',
  QUARTERLY: '90',
};

const CONTENT_TO_NEWS_TYPE: Array<{ content: string; type: string }> = [
  { content: 'all_news', type: 'Chronological' },
  { content: 'top_news', type: 'Relevant' },
  { content: 'curated_news', type: 'Bookmarked' },
  { content: 'stories', type: 'Stories' },
  { content: 'summary', type: 'Summary' },
];

const FILTER_FIELDS_TO_COPY = [
  'time',
  'filter',
  'lang',
  'feed',
  'event_ids',
  'categories',
  'continents',
  'countries',
  'factuality',
  'temporality',
  'ranks',
  'panels',
] as const;

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-newsletter',
  templateUrl: './newsletter.component.html',
  styleUrls: ['./newsletter.component.scss'],
})
export class NewsletterComponent implements OnDestroy {
  $newsletters: Observable<any>;
  allNewsletters: any;
  newsletter: any;
  private newsletterParams: any = {};
  newsletterParamsReady = false;
  params: any;
  previousValue: any;
  previousUrl: any;
  scrollDistance = 0;
  tabWidth = 191;
  tabsNumber = 0;
  project: string;
  blankNewsletter = {
    uid: '',
    contents: [],
    displayables: [],
    dispObjects: [
      {
        type: 'entity',
        payload: '',
        view: '',
      },
    ],
    header_image: this.auth.featureFlags.newsletterBanner
      ? this.auth.featureFlags.newsletterBanner
      : '',
    logo: this.auth.featureFlags.newsletterLogo
      ? this.auth.featureFlags.newsletterLogo
      : 'https://yl-newsletters-logos-v1.s3.amazonaws.com/Logo_YUKKA_News-Analytics_Transparent.png',
    disclaimer: this.auth.featureFlags.newsletterDisclaimer
      ? this.auth.featureFlags.newsletterDisclaimer
      : '',
    from_email: this.auth.featureFlags.newsletterEmail
      ? this.auth.featureFlags.newsletterEmail
      : '',
    active: false,
    hide_sentiment_bars: false,
    recipients: [],
    recommended_news_phrases: [''],
    recommended_news_num_articles: 50,
    recommended_news_threshold: 0.05,
    all_news_max_number: 20,
    top_news_max_number_default: 7,
    stories_max_number_default: 10,
  };

  @ViewChild(MatTabNav) public matTabNav: MatTabNav;

  private ngUnsubscribe = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public routing: RoutingService,
    public auth: AuthService,
    private portfolioApi: PortfolioApiService,
    private queryApi: QueryApiService,
    private filterApi: FilterApiService,
    private newsletterApi: NewsletterApiService,
    public config: ConfigService,
    public newsletterService: NewsletterService,
  ) {
    this.newsletterService.newsletter = this.newsletter;
    this.project = this.config.appConfig.routing.project;

    this.router.events
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.handleNavigationEnd(event.url);
        }
      });

    this.route.queryParams
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((params) => {
        this.params = params;
        this.syncFilterParam(params);
        if (this.routing.reFresh(params, this.previousValue, ['id', 'rdn'])) {
          this.handleIdChange(params);
        }
        this.triggerTabReflow();
        this.previousValue = params;
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  addNewsletter() {
    this.router.navigate([], {
      queryParams: { id: 'create' },
      queryParamsHandling: 'merge',
      replaceUrl: true,
    });
  }

  inTabNewsletter(uid) {
    this.scrollDistance = this.matTabNav.scrollDistance;
    this.router.navigate([], {
      queryParams: {
        id: uid,
        rdn: null,
      },
      queryParamsHandling: 'merge',
    });
  }

  inDelete(uid) {
    if (window.confirm('Do you want to delete this newsletter?')) {
      this.newsletterApi.removeNewsletter(uid).subscribe(() => {
        if (uid === this.params.id) {
          this.newsletter = JSON.parse(JSON.stringify(this.blankNewsletter));
          this.router.navigate([], {
            queryParams: { id: null, rdn: Math.random() },
            queryParamsHandling: 'merge',
            replaceUrl: true,
          });
        }
        this.$newsletters = this.newsletterApi.allNewsletter();
      });
    }
  }

  checkCurrentNewsletterIndex(item, allItems) {
    const currentNewsletterId = this.params.id;
    let current;
    let previous;
    allItems.forEach((el, index) => {
      if (currentNewsletterId === el.uid) {
        current = el.uid;
        if (index > 0) {
          previous = allItems[index - 1].uid;
        }
      }
    });
    if (current === item) {
      return true;
    } else if (previous && previous === item) {
      return true;
    } else {
      return false;
    }
  }

  private handleNavigationEnd(url: string): void {
    const currentUrl = url.split('?')[0];
    if (currentUrl !== this.previousUrl) {
      if (this.newsletter && this.allNewsletters) {
        this.scrollDistance = this.tabWidth * this.findTabIndex();
        this.tabsNumber = this.allNewsletters.length;
      }
      this.applyScrollDistanceToMatTab();
    }
    this.previousUrl = currentUrl;
  }

  private syncFilterParam(params: any): void {
    if (!this.routing.reFresh(params, this.previousValue, ['filter'])) {
      return;
    }
    if (params.filter) {
      Object.assign(this.newsletterParams, { filter: params.filter });
    } else if (this.newsletterParams.hasOwnProperty('filter')) {
      delete this.newsletterParams['filter'];
    }
  }

  private handleIdChange(params: any): void {
    const canSelectFromCache =
      !params.rdn && this.allNewsletters && params.id !== 'create';

    if (canSelectFromCache) {
      this.selectFromCachedList(params);
      this.ensureFallbackNewsletter();
    } else {
      this.reloadListAndSelect(params);
    }
  }

  private selectFromCachedList(params: any): void {
    this.allNewsletters.forEach((data) => {
      if (!params.id) {
        this.navigateToFirstNewsletter(this.allNewsletters);
      } else if (params.id === data.uid) {
        this.selectNewsletter(data);
      }
    });
  }

  private reloadListAndSelect(params: any): void {
    this.newsletter = undefined;
    this.newsletterParamsReady = false;
    this.newsletterService.newsletterParamsReady = false;
    this.$newsletters = this.newsletterApi.allNewsletter();
    this.$newsletters
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((result) => {
        this.allNewsletters = result;
        result.forEach((data) => {
          if (!params.id) {
            this.navigateToFirstNewsletter(result);
          } else if (params.id === data.uid) {
            this.selectNewsletter(data);
          }
        });
        this.ensureFallbackNewsletter();
      });
  }

  private ensureFallbackNewsletter(): void {
    if (!this.newsletter) {
      this.newsletter = JSON.parse(JSON.stringify(this.blankNewsletter));
    }
    this.newsletterService.newsletter = this.newsletter;
  }

  private navigateToFirstNewsletter(list: any[]): void {
    const sorted = [...list].sort((a, b) => a.title.localeCompare(b.title));
    this.router.navigate([], {
      queryParams: { id: sorted[0].uid, rdn: null },
      queryParamsHandling: 'merge',
      replaceUrl: true,
    });
  }

  private selectNewsletter(data: any): void {
    this.newsletter = data;
    this.newsletterParams = {};
    this.updateTabScroll();
    this.hydrateDeliveryDefaults();
    this.hydrateNewsSettingsDefaults();
    this.parseDisplayables();
    this.applyFrequencyToParams();
    this.applyContentTypeToParams();
    this.applyFilterAndDispatchDispObject();
  }

  private updateTabScroll(): void {
    const currentLength = this.allNewsletters.length;
    if (currentLength > this.tabsNumber) {
      this.scrollDistance = this.tabWidth * this.findTabIndex();
    } else if (currentLength === this.tabsNumber) {
      if (this.findTabIndex() === 0) {
        this.scrollDistance = 0;
      }
    } else if (currentLength < this.tabsNumber) {
      this.scrollDistance = 0;
    }
    this.tabsNumber = currentLength;
    this.applyScrollDistanceToMatTab();
  }

  private applyScrollDistanceToMatTab(): void {
    if (this.matTabNav) {
      setTimeout(() => {
        this.matTabNav.scrollDistance = this.scrollDistance;
      }, 100);
    }
  }

  private findTabIndex(): number {
    const sorted = [...this.allNewsletters].sort((a, b) =>
      a.title.localeCompare(b.title),
    );
    const idx = sorted.findIndex((n) => n.uid === this.params.id);
    return idx >= 0 ? idx : 0;
  }

  private hydrateDeliveryDefaults(): void {
    const delivery = this.newsletter.delivery_settings;
    if (!delivery) {
      return;
    }
    if (
      delivery.hasOwnProperty('delivery_time') &&
      this.newsletter.delivery_time !== null
    ) {
      this.newsletter.delivery_time = delivery.delivery_time;
    }
    if (
      delivery.hasOwnProperty('frequency') &&
      this.newsletter.frequency !== null
    ) {
      this.newsletter.frequency = delivery.frequency;
    }
  }

  private hydrateNewsSettingsDefaults(): void {
    const news = this.newsletter.news_settings;
    if (!news) {
      return;
    }
    if (news.hasOwnProperty('all_news_max_number')) {
      this.newsletter.all_news_max_number = news.all_news_max_number || 20;
    }
    if (
      news.hasOwnProperty('recommended_news_max_number') &&
      this.newsletter.recommended_news_num_articles !== null
    ) {
      this.newsletter.recommended_news_num_articles =
        news.recommended_news_max_number;
    }
    if (
      news.hasOwnProperty('recommended_news_phrases') &&
      this.newsletter.recommended_news_phrases !== null
    ) {
      this.newsletter.recommended_news_phrases = news.recommended_news_phrases;
    }
    if (
      news.hasOwnProperty('recommended_news_threshold') &&
      this.newsletter.recommended_news_threshold !== null
    ) {
      this.newsletter.recommended_news_threshold =
        news.recommended_news_threshold;
    }
    if (news.hasOwnProperty('stories_max_number')) {
      this.newsletter.stories_max_number = news.stories_max_number || 10;
    }
    if (news.hasOwnProperty('top_news_max_number')) {
      this.newsletter.top_news_max_number = news.top_news_max_number || 7;
    }
  }

  private parseDisplayables(): void {
    if (!this.newsletter.displayables) {
      return;
    }
    this.newsletter.dispObjects = [];
    this.newsletter.displayables.forEach((item: string) => {
      const parts = item.split(':');
      if (parts.length === 4) {
        this.newsletter.dispObjects.push({
          type: parts[2],
          payload: parts[3],
          view: '',
        });
      } else if (parts.length === 5) {
        this.newsletter.dispObjects.push({
          type: parts[2],
          payload: parts[3] + ':' + parts[4],
          view: '',
        });
      }
    });
  }

  private applyFrequencyToParams(): void {
    const time = FREQUENCY_TO_TIME[this.newsletter.frequency];
    if (time) {
      Object.assign(this.newsletterParams, { time });
    }
  }

  private applyContentTypeToParams(): void {
    const match = CONTENT_TO_NEWS_TYPE.find((m) =>
      this.newsletter.contents.includes(m.content),
    );
    if (match) {
      Object.assign(this.newsletterParams, { newstype: match.type });
    }
  }

  private applyFilterAndDispatchDispObject(): void {
    this.filterApi
      .getFilter()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((filters) => {
        this.mergeFilterIntoParams(filters);
        this.dispatchDispObject();
      });
  }

  private mergeFilterIntoParams(filters: any[]): void {
    if (!this.newsletter.cockpit_filter_id) {
      return;
    }
    const match = filters.filter(
      (item) => item.id === this.newsletter.cockpit_filter_id,
    )[0];
    if (!match) {
      return;
    }
    FILTER_FIELDS_TO_COPY.forEach((field) => {
      if (match[field]) {
        Object.assign(this.newsletterParams, { [field]: match[field] });
      }
    });
  }

  private dispatchDispObject(): void {
    const first = this.newsletter.dispObjects && this.newsletter.dispObjects[0];
    if (!first) {
      return;
    }
    switch (first.type) {
      case 'entity':
        this.assignEntityParams(first.payload);
        this.markParamsReadyAndRefresh();
        break;
      case 'portfolio':
        this.portfolioApi
          .portFolio(first.payload)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe((result) => {
            Object.assign(this.newsletterParams, {
              type: 'portfolio',
              id: first.payload,
              payload: result.content,
            });
            this.markParamsReadyAndRefresh();
          });
        break;
      case 'search_query_group':
        this.queryApi
          .getQueryGroup(first.payload)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe((result) => {
            const groups = result.map((element: any) => element.query);
            Object.assign(this.newsletterParams, {
              type: 'search_query',
              id: first.payload,
              payload: { operator: 'or', filters: [], groups },
            });
            this.markParamsReadyAndRefresh();
          });
        break;
      case 'search_query':
        this.queryApi
          .getQuery()
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe((result) => {
            const payload = result.filter(
              (item: any) => item.uid === first.payload,
            )[0].query;
            Object.assign(this.newsletterParams, {
              type: 'search_query',
              id: first.payload,
              payload,
            });
            this.markParamsReadyAndRefresh();
          });
        break;
    }
  }

  private assignEntityParams(payload: string): void {
    const [type, id] = payload.split(':');
    Object.assign(this.newsletterParams, { type, id, payload });
  }

  private markParamsReadyAndRefresh(): void {
    this.newsletterParamsReady = true;
    this.newsletterService.newsletterParamsReady = true;
    this.router.navigate([], {
      queryParams: { update: Math.random() },
      queryParamsHandling: 'merge',
      replaceUrl: true,
    });
  }

  private triggerTabReflow(): void {
    if (this.routing.reFresh(this.params, this.previousValue, ['reflow'])) {
      setTimeout(() => {
        if (this.matTabNav) {
          this.matTabNav._alignInkBarToSelectedTab();
        }
      }, 500);
    }
  }
}
